import AppPackageJson from "../../package.json";

export const AppPackage = Object.assign({
    version: AppPackageJson.version
}, AppPackageJson);